import * as Locales from 'date-fns/locale';
import { DateTime } from 'luxon';
import { registerLocale } from 'react-datepicker';

const USER_LANG = navigator.language;

export const registerLocalLocale = (): void => {
  switch (USER_LANG) {
    case 'en-GB':
      registerLocale('en-GB', Locales.enGB);
      break;
    default:
      registerLocale('en-US', Locales.enUS);
      break;
  }
};

const getAppLocale = (): string => localStorage.getItem('user_language') || 'en';

/**
 * Formats a Luxon DateTime as "D MMM YYYY" (e.g. "13 Oct 2026") in the
 * user's current app language. The order is always day-month-year regardless
 * of locale; only the month abbreviation is translated.
 */
export const formatLocalizedDate = (dt: DateTime): string => {
  const locale = getAppLocale();
  const parts = new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).formatToParts(dt.toJSDate());
  const map: Record<string, string> = {};
  for (const p of parts) map[p.type] = p.value;
  return `${map.day} ${map.month} ${map.year}`;
};

/**
 * Formats a Luxon DateTime as a medium datetime string localised to the
 * user's current app language (e.g. "13 Oct 2026, 14:30").
 */
export const formatLocalizedDateTime = (dt: DateTime): string =>
  dt.setLocale(getAppLocale()).toLocaleString(DateTime.DATETIME_MED);
